import apiService from '@dishopsaas/dishop-backend-api-service'
import { applicationError } from '../utils/applicationError'

const isDev = false

const backendUrl = isDev ? `http://localhost:9086/` : 'https://dev-backend-v2.dishop.co/'

apiService.init(backendUrl, err => {
  const { msg = 'apiError', ...options } = err
  applicationError(msg, options)
}, 'admin')

export function backendV2SetDefaultShop(companyId) {
  apiService.setDefaultDatabase(companyId)
  apiService.setHeaders({ companyId }, true)
}

export function backendV2auth(firebaseToken) {
  apiService.setHeaders({ authorization: firebaseToken }, true)
}